import { React } from "react";
import { Box, Typography, Paper } from "@mui/material";



function CaptionItem({ label, color }) {
    const componentStyle = { width: "15px", height: "15px", backgroundColor: color, position: "relative", left: 15, top: 25 }
    const typographyStyle = {
        fontSize: 12,
        position: 'relative',
        left: 50,
        top: 9
    }
    return <><Paper style={componentStyle}></Paper>
        <Typography style={typographyStyle}>{label}</Typography></>
}

export default function MarkersCaption() {



    return <Box width="150px" height="130px" position='relative' top="400px" >
        <CaptionItem label="Posição atual" color="green" />
        <CaptionItem label="Posição anterior" color="gray" />
        <CaptionItem label="Falta de info" color="red" />

    </Box >

}